import 'swiper/css'
import 'swiper/css/lazy'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { styled } from '@atom-web/core'
import { Box, Row } from '@atom-web/micros'
import Image from 'next/image'
import { lazy, useState } from 'react'
import { FreeMode, Navigation, Pagination, Thumbs } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import getImgIXUrl from '../../../../utils/getImgIXUrl'
import isMobile from '../../../../utils/isMobile'

export const SliderWrapper = styled(Box, {
	display: 'flex',
	'& div.swiper-button-disabled': {
		opacity: 0,
	},
	'& .swiper-button-prev , .swiper-button-next': {
		opacity: 0,
	},
	'@hover': {
		'&:hover': {
			'& .swiper-button-prev, .swiper-button-next': {
				opacity: 1,
			},
			'& .swiper-button-disabled': {
				opacity: 0,
			},
			'& .swiper-button-prev , .swiper-button-next': {
				opacity: 1,
				boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.2)',
				borderRadius: '$round',
				backgroundColor: 'white',
				width: 24,
				height: 24,
				color: 'black',
				fontWeight: '$extrabold',
				textAlign: 'center',
				top: '44%',
				'&:after': {
					fontSize: '12px',
				},
				marginTop: 1,
			},
		},
	},

	'& .swiper-pagination-bullet': {
		backgroundColor: '$white',
		height: 8,
		width: 10,
		opacity: 0.8,
		borderRadius: '$pill',
	},
	'& .swiper-pagination-bullet-active': {
		width: 20,
		height: 8,
		opacity: 2,
		borderRadius: '$pill',
		backgroundColor: '$white',
	},
	'& .swiper-slide > span': {
		width: '100% !important',
		height: '100% !important',
	},

	'& .mySwiper > .swiper-wrapper > .swiper-slide': {
		height: 88,
		width: '144px !important',
		opacity: 0.8,
		borderRadius: '$3',
		overflow: 'hidden',
	},
	'& .mySwiper  > .swiper-wrapper > .swiper-slide-thumb-active': {
		opacity: 1,
		border: '4px solid #FFC933',
		borderRadius: '$3',
		height: '96px',
	},
})

const myLoader = ({ src, width, quality }) => {
	return `${src}?w=${width}&q=${quality || 75}`
}

export const ImageSlider = ({
	imageList,
	showThumbs = false,
	alt,
	borderleftradius = '$3',
	borderTopRightRadius = 0,
}) => {
	const [thumbsSwiper, setThumbsSwiper] = useState(null)
	return showThumbs ? (
		<>
			{thumbsSwiper && (
				<SliderWrapper>
					<Row
						css={{
							width: '100%',
							height: 355,
							overflow: 'hidden',
							'@lg': {
								borderRadius: '$3',
							},
							'@smMax': {
								width: 'calc(100% - 24px)',
								height: '260px',
								justifyContent: 'center',
								alignItems: 'center',
								margin: 'auto',
							},
						}}
					>
						{imageList?.length ? (
							<Swiper
								navigation={true}
								thumbs={{
									swiper:
										thumbsSwiper && !thumbsSwiper.destroyed
											? thumbsSwiper
											: null,
								}}
								lazy={true}
								preloadImages={false}
								modules={[Navigation, Thumbs, lazy]}
							>
								{imageList?.map((item, inx) => (
									<SwiperSlide key={inx}>
										<Image
											loader={myLoader}
											src={
												getImgIXUrl(
													item,
													isMobile()
														? 'w=256&fit=crop'
														: 'w=864&h=355&fit=crop',
													75,
													2,
													false,
												) ||
												'https://pyt-images.imgix.net/images/costing_screen/placeholder/desktop/hotels.png'
											}
											alt={alt}
											width={'100%'}
											height={220}
											layout="fill"
										/>
									</SwiperSlide>
								))}
							</Swiper>
						) : null}
					</Row>
				</SliderWrapper>
			)}
			<SliderWrapper css={{ width: '100%', marginTop: 84 }}>
				<Row
					css={{
						width: '100%',
						height: 96,
						borderRadius: '$3',
						overflow: 'hidden',
					}}
					align="center"
				>
					<Swiper
						navigation={true}
						onSwiper={swiper => setThumbsSwiper(swiper)}
						spaceBetween={24}
						slidesPerView={'auto'}
						freeMode
						watchSlidesProgress
						modules={[FreeMode, Thumbs, Navigation]}
						className="mySwiper"
					>
						{imageList?.map((item, inx) => (
							<SwiperSlide key={inx}>
								<Image
									loader={myLoader}
									src={
										getImgIXUrl(item, 'w=120&fit=crop') ||
										'https://pyt-images.imgix.net/images/costing_screen/placeholder/desktop/hotels.png'
									}
									alt={alt}
									width={120}
									height={88}
								/>
							</SwiperSlide>
						))}
					</Swiper>
				</Row>
			</SliderWrapper>
		</>
	) : (
		<SliderWrapper css={{ height: '100%', width: '100%' }}>
			<Swiper
				// spaceBetween={30}
				lazy={true}
				navigation={true}
				loop={true}
				pagination={{
					clickable: true,
					dynamicBullets: true,
				}}
				modules={[Navigation, Pagination, lazy]}
			>
				{imageList?.map((item, inx) => (
					<SwiperSlide key={inx}>
						<Box
							css={{
								position: 'relative',
								overflow: 'hidden',
								width: '100vw',
								height: '100%',
								zIndex: 1,
								'@lg': {
									borderTopLeftRadius: '$4',
									borderTopRightRadius: borderTopRightRadius,
									borderBottomLeftRadius: borderleftradius,
								},
							}}
						>
							<Image
								loader={myLoader}
								src={item}
								alt={alt}
								layout="fill"
								objectFit="cover"
							/>
						</Box>
					</SwiperSlide>
				))}
			</Swiper>
		</SliderWrapper>
	)
}
